import React from 'react';
// Images
import Image1 from '../../assets/images/main/miss-dom-3.jpg';
import Image2 from '../../assets/images/reviews/misress-diva-pro-dominatrix-and-femdom-review2.webp';
import Image3 from '../../assets/images/reviews/misress-diva-pro-dominatrix-and-femdom-review3.jpg';
import Image4 from '../../assets/images/reviews/misress-diva-pro-dominatrix-and-femdom-review4.webp';
import Image5 from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-red-blowing-pin-wheel.webp';
// Components
import ReviewItem from './ReviewItem';
import { reviewsArray } from '../../utils/data/ReviewData';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

const groupIntoPairs = (arr) => {
  const out = [];
  for (let i = 0; i < arr.length; i += 2) out.push(arr.slice(i, i + 2));
  return out;
};

const sectionImages = [Image1, Image2, Image3, Image5];

function ReviewsPageMainContainer() {
  const groups = groupIntoPairs(reviewsArray); // 2 reviews per group

  return (
    <main className='grid w-full' role='main' aria-labelledby='reviews-title'>
      <section className='grid place-items-center text-center py-6 px-8 md:px-12 lg:px-44'>
        <h3
          id='reviews-title'
          className='text-xl md:text-2xl font-kugile text-[#d9d9d9]'
        >
          Client Reviews & Testimonials
        </h3>
      </section>

      <div className='grid gap-y-10 px-8 md:px-12 lg:px-44'>
        {groups.map((group, idx) => {
          const imgSrc =
            sectionImages[idx] || sectionImages[sectionImages.length - 1];
          const imageLeftOnDesktop = idx % 2 === 0; // alternate
          const sectionId = `reviews-section-${idx + 1}`;

          return (
            <section
              key={sectionId}
              id={sectionId}
              className='grid'
              aria-labelledby={`${sectionId}-title`}
            >
              {/* Accessible but not visually noisy section title */}
              <h3 id={`${sectionId}-title`} className='sr-only'>
                Reviews block {idx + 1}
              </h3>

              <div className='grid lg:grid-cols-2 gap-x-8'>
                {/* Reviews first on mobile (2 reviews), image after; on desktop we alternate sides */}
                <div
                  className={`grid h-full items-center gap-4 order-1 ${
                    imageLeftOnDesktop ? 'lg:order-2' : 'lg:order-1'
                  }`}
                >
                  <ul className='grid lg:h-fit gap-4'>
                    {group.map((rev, rIdx) => (
                      <li key={`review-${idx}-${rIdx}`} className='grid'>
                        <ReviewItem
                          author={rev.author}
                          date={rev.date}
                          content={rev.content}
                        />
                      </li>
                    ))}
                  </ul>
                </div>

                <figure
                  className={`grid order-2 ${
                    imageLeftOnDesktop ? 'lg:order-1' : 'lg:order-2'
                  }`}
                >
                  <img
                    src={imgSrc}
                    alt='Mistress Diva — client reviews visual'
                    className='w-full h-full object-cover'
                    loading='lazy'
                    decoding='async'
                  />
                  <figcaption className='sr-only'>
                    Artistic portrait used to accompany client testimonials.
                  </figcaption>
                </figure>
              </div>
            </section>
          );
        })}

        {/* Final image pinned beneath all reviews */}
        <section className='grid' aria-labelledby='closing-image-title'>
          <h3 id='closing-image-title' className='sr-only'>
            Closing image
          </h3>
          <figure className='grid'>
            <img
              src={Image4}
              alt='Mistress Diva — closing visual'
              className='w-full h-full object-cover'
              loading='lazy'
              decoding='async'
            />
            <figcaption className='sr-only'>
              Closing artwork beneath all testimonials.
            </figcaption>
          </figure>
        </section>
      </div>

      <SocialMediaCtaComponent />
    </main>
  );
}

export default ReviewsPageMainContainer;
